import { generatePath } from 'quartz-routing/react-router';
import { AWARD_SHARE_BACK_PARAM, AWARD_SHARE_CODE_PARAM, AWARD_SHARE_TITLE_PARAM } from '../../constants/AwardShareConsts';
import { SHARE_ACHIEVEMENT_URL_FRAGMENT } from '../../routes/academyRoutePaths';

/**
 * The award-share page is reachable from both apps, so anything it needs has to
 * travel in the search string — a cross-app click is a full page load, and
 * `history.createHref` does not serialise router state.
 */
export const getAwardShareLocation = ({
  backLocation,
  code,
  grantedCredentialId,
  title
}) => {
  const searchParams = new URLSearchParams();
  if (code) {
    searchParams.set(AWARD_SHARE_CODE_PARAM, code);
  }
  if (title) {
    searchParams.set(AWARD_SHARE_TITLE_PARAM, title);
  }
  if (backLocation) {
    searchParams.set(AWARD_SHARE_BACK_PARAM, `${backLocation.pathname}${backLocation.search}`);
  }
  return {
    pathname: generatePath(SHARE_ACHIEVEMENT_URL_FRAGMENT, {
      grantedCredentialId
    }),
    search: searchParams.toString()
  };
};